import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

export default class Bird extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.body = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._animations_bird_idle_0);
        this.add(this.body);

        this.eyes = this.scene.add.sprite(148, 17, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._animations_eye_idle_0);
        this.add(this.eyes);

        this.eyeIdlePos = { x: 148, y: 17 };
        this.eyeFlyingPos = { x: 159, y: 19 };

        this.body.anims.create(
            {
                key: BIRD_ANIMATIONS.fly,
                defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
                frames:
                    [
                        { frame: UIAssetKeys._animations_bird_fly_0 },
                        { frame: UIAssetKeys._animations_bird_fly_0 },
                        { frame: UIAssetKeys._animations_bird_fly_0 },
                        { frame: UIAssetKeys._animations_bird_fly_3 },
                        { frame: UIAssetKeys._animations_bird_fly_3 },
                        { frame: UIAssetKeys._animations_bird_fly_3 },
                    ],
                repeat: -1
            }
        );

        this.body.anims.create(
            {
                key: BIRD_ANIMATIONS.idle,
                defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
                frames:
                    [
                        { frame: UIAssetKeys._animations_bird_idle_0 },
                    ],
            }
        );

        this.eyes.anims.create(
            {
                key: EYE_BLINK,
                defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
                frames:
                    [
                        { frame: UIAssetKeys._animations_eye_idle_0 },
                        { frame: UIAssetKeys._animations_eye_blink_1 },
                        { frame: UIAssetKeys._animations_eye_blink_1 },
                        { frame: UIAssetKeys._animations_eye_blink_1 },
                        { frame: UIAssetKeys._animations_eye_idle_0 },
                    ],
                frameRate: 12
            }
        );

        this.blinkEye();

        this.once(Phaser.GameObjects.Events.DESTROY, () => this.blinkDelayedCall?.remove());
    }

    flyTo(xPos, yPos, time)
    {
        this.scene.tweens.killTweensOf(this);
        //add curve to fly with yoyo rotation tween
        ABCyaPhaser.Tweens.addTween(this, time, { x: xPos, y: yPos }, Phaser.Math.Easing.Quadratic.In, this.finishFlight.bind(this));

        this.body.play(BIRD_ANIMATIONS.fly);
        this.eyes.setPosition(this.eyeFlyingPos.x, this.eyeFlyingPos.y);
    }

    jumpTo(xPos, yPos, time)
    {
        this.scene.tweens.killTweensOf(this);
        let startX = this.x;
        const path = new Phaser.Curves.Path(this.x, this.y).quadraticBezierTo(xPos, yPos, startX + ((xPos - startX) / 2), yPos - 400);
        /** @type {Phaser.Tweens.Tween} */
        this._pathTween = ABCyaPhaser.Tweens.addPathTween(this, path, time, null, Phaser.Math.Easing.Quadratic.InOut, this.finishFlight.bind(this));

        this.body.play(BIRD_ANIMATIONS.fly);
        this.eyes.setPosition(this.eyeFlyingPos.x, this.eyeFlyingPos.y);
    }

    finishFlight()
    {
        this.body.stop().play(BIRD_ANIMATIONS.idle);
        this.eyes.setPosition(this.eyeIdlePos.x, this.eyeIdlePos.y);

        this.emit(FLIGHT_ENDED);
    }

    blinkEye()
    {
        this.blinkDelayedCall = this.scene.time.delayedCall(Phaser.Math.Between(1500, 3000), () =>
        {
            this.eyes.play(EYE_BLINK, true);
            this.blinkEye();
        });
    }

    killTweens()
    {
        this.scene.tweens.killTweensOf(this);
        this._pathTween?.stop();
    }
}

export const FLIGHT_ENDED = "FLIGHT_ENDED";

const BIRD_ANIMATIONS =
{
    fly: "bird-fly",
    idle: "bird-idle",
}

const EYE_BLINK = "eye-blink";